import Http from '../../common/services/Http';
import { Paged } from '../common/types/Page';
import { SelectValueLabelIsSystem } from 'common/types/SelectValueLabel';
import { MaintenanceContractTypeDto, MaintenanceContractTypeIconDto } from './models/MaintenanceContractTypeDto';
import { MaintenanceContractTypesSearchCriteria } from './models/MaintenanceContractTypesSearchCriteria';
import { CatalogMaintenanceContractTypesSearchCriteria } from '../catalog/models/CatalogMaintenanceContractTypesSearchCriteria';

class MaintenanceContractTypesService {
    public getList(criteria: MaintenanceContractTypesSearchCriteria) {
        return Http.get<Paged<MaintenanceContractTypeDto>>('maintenancecontracttypes', criteria);
    }

    public catalog(criteria?: CatalogMaintenanceContractTypesSearchCriteria) {
        return Http.get<SelectValueLabelIsSystem[]>('maintenancecontracttypes/catalog', criteria);
    }

    public catalogIcons() {
        return Http.get<MaintenanceContractTypeIconDto[]>('maintenancecontracttypes/icons-catalog');
    }

    public getById(id: string) {
        return Http.get<MaintenanceContractTypeDto>('maintenancecontracttypes/' + id);
    }

    public create(model: MaintenanceContractTypeDto) {
        return Http.post<string>('maintenancecontracttypes', model);
    }

    public update(model: MaintenanceContractTypeDto) {
        return Http.put('maintenancecontracttypes', model);
    }

    public remove(model: MaintenanceContractTypeDto) {
        return Http.put('maintenancecontracttypes/deactivate', model);
    }
}

export default new MaintenanceContractTypesService();
